import {useCallback, useReducer} from "react";
import {client} from "../../api/client";
import useToken from "../useToken";

function reducer(state, action) {
    switch (action.type) {
        case 'FETCH':
            return { ...state, loading: true, apiErrors: null }
        case 'SET_RESULT':
            return { ...state, loading: false, apiErrors: null, result: action.payload }
        case 'ADD_ERRORS':
            return { ...state, loading: false, apiErrors: action.payload }
        default:
            throw new Error('Action inconnue ' + action.type)
    }
}

export function useUserCommentHistory() {
    const {token} = useToken()
    const [state, dispatch] = useReducer(reducer, {
        loading: false,
        result: null,
        apiErrors: null,
    })

    const fetchHistory = useCallback(async (userId, {date, page}) => {
        dispatch({type: 'FETCH'})

        const params = {}
        if (date) {
            params.date = date.toLocaleDateString('fr').replaceAll('/', '-')
        }
        if (page) {
            params.page = String(page)
        }

        client(`users/${userId}/comments`, {token, params})
            .then(result => {
                dispatch({type: 'SET_RESULT', payload: {
                    comments: result.comments,
                    metaData: result.metaData,
                }})
            })
            .catch(result => {
                dispatch({type: 'ADD_ERRORS', payload: result?.errors ?? null})
            })
    }, [token])

    return [state, {fetchHistory}]
}
